import { useWatch } from 'react-hook-form'
import { SubmitButton } from '@ui/forms'
import type { DefaultValues } from '..'

interface Props {
  loading: boolean
  isUpdatingChecks: boolean
}

/** Disabled until "Ändern" unlocks the shared form cross section. */
const MultiEditSubmitButton = ({ loading, isUpdatingChecks }: Props) => {
  const crossSection = useWatch<DefaultValues>({ name: 'crossSection' })
  return <SubmitButton loading={loading} disabled={isUpdatingChecks || !crossSection} />
}

export default MultiEditSubmitButton
